const t = "tag_iPkxD", a = {
  tag: t
};
export {
  a as default,
  t as tag
};
//# sourceMappingURL=userTag.module.scss.js.map
